// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"7c60ae09","641":"64252f17"}[chunkId] + ".css";
};